const TTL_MS = 24 * 60 * 60 * 1000; // 24h
const DISABLE_CACHE = true; // Flip to true only when debugging cache issues
const inflight = new Map();

function lsGet(key) { try { return JSON.parse(localStorage.getItem(key) || "null"); } catch { return null; } }
function lsSet(key, value) {
  if (DISABLE_CACHE) return;
  try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
}

export function readFreshCache(key) {
  if (DISABLE_CACHE) return null;
  const c = lsGet(key);
  return c && Date.now() - c.ts < TTL_MS ? c.data : null;
}

export function invalidate(key) {
  try { localStorage.removeItem(key); } catch {}
}

export async function cachedPost({ key, url, headers, body, force = false }) {
  const skipCache = DISABLE_CACHE || force;
  const now = Date.now();
  if (!skipCache) {
    const cached = lsGet(key);
    if (cached && now - cached.ts < TTL_MS) return cached.data;
  }
  if (inflight.has(key)) return inflight.get(key);

  const p = fetch(url, { method: "POST", headers, body })
    .then(async (res) => {
      if (!res.ok) throw new Error(`Failed: ${url}`);
      const data = await res.json();
      if (!DISABLE_CACHE) lsSet(key, { ts: Date.now(), data });
      return data;
    })
    .finally(() => inflight.delete(key));

  inflight.set(key, p);
  return p;
}
